/** @format */

import { useQuery } from "@tanstack/react-query";
import service from "../utils/service"

const useGetRegions = () => {
  const regions = useQuery({
    queryKey: ["getRegions"],
    queryFn: () => service.getChannelRegions(),
    select: (data) => data.data,
    cacheTime: Infinity,
    staleTime: Infinity
  });
  return regions;
};

export default useGetRegions;